export const playTimes = [2000, 4000, 6000, 9000, 12000, 16000];
